export const PRONTUARIO_ACTION_LABELS: Record<string, string> = {
  CREATE: "CRIAÇÃO",
  UPDATE: "EDIÇÃO",
};

export function getProntuarioActionLabel(action: string) {
  if (!action) return "EDIÇÃO";
  return PRONTUARIO_ACTION_LABELS[action] ?? "EDIÇÃO";
}
